import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Order } from 'src/app/models/order.model';

@Component({
  selector: 'app-detail-header',
  template: `
    @if (browserSize === 'small') {
      <div
        class="back-heading z-[1] flex h-11 w-full items-center bg-gradient-to-r from-gray-200 to-white pl-5 pr-6 text-base text-cobalt-500"
      >
        <a
          class="back-link icon-text flex items-center text-base text-cobalt-500 hover:text-cobalt-400"
          [routerLink]="['/orders']"
        >
          <div class="custom-icon arrow_back mr-2 w-3 pt-3 leading-3"></div>
          Back to Order Status
        </a>
      </div>
    }
    <div class="mx-0 max-[767px]:mx-5">
      <div
        class="z-[9] flex items-center justify-between bg-white text-base font-thin text-cobalt-500 max-[860px]:flex-col max-[860px]:items-start max-[860px]:justify-start max-[860px]:gap-2 max-[767px]:flex-row max-[767px]:items-center max-[767px]:justify-between max-[767px]:pt-6 max-[400px]:flex-col"
      >
        <h2
          class="flex items-center text-lg font-bold text-cobalt-500 max-[1024px]:text-[17px] max-[860px]:ml-[-3px]"
        >
          <mat-icon class="mr-1 !h-5 !w-5 text-[1.25rem]">
            account_tree
          </mat-icon>
          {{ order.Name || '' }} ({{
            order.Status__c === 'Ready' ? 'Pending' : order.Status__c
          }})
        </h2>
        @if (order.Order_Date__c) {
          <div
            class="mt-1 text-sm font-normal uppercase text-cobalt-500 max-[1024px]:text-xs max-[860px]:ml-5 max-[767px]:mt-0"
          >
            Order Date:
            <span class="ml-1.5 font-bold">{{
              order.Order_Date__c | date: 'MM/dd/yy'
            }}</span>
          </div>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DetailHeaderComponent {
  @Input() order: Order;

  @Input() browserSize: string;
}
